var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrips1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3669_29180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 2C15.552 2 16 2.47289 16 3.05556V6.16667H21C21.552 6.16667 22 6.63956 22 7.22222V20.9444C22 21.5271 21.552 22 21 22H3C2.448 22 2 21.5271 2 20.9444V7.22222C2 6.63956 2.448 6.16667 3 6.16667H8V3.05556C8 2.47289 8.448 2 9 2H15ZM16 8.27778H8V19.8889H16V8.27778ZM4 8.27778V19.8889H6V8.27778H4ZM14 4.11111H10V6.16667H14V4.11111ZM18 8.27778V19.8889H20V8.27778H18Z",
    fill: "#344054"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3669_29180"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrips1);
export default __webpack_public_path__ + "static/media/trips_1.3f5e0e07.svg";
export { ForwardRef as ReactComponent };